import type { BoxProps, ThemingProps} from '@chakra-ui/react'
import { Box, useStyleConfig } from '@chakra-ui/react'

interface ComponentProps extends BoxProps, ThemingProps {
  children: React.ReactNode
}

export const Section = (props: ComponentProps) => {
  const { variant, sx, ...rest } = props

  const styles = useStyleConfig('Section', { variant })

  return <Box __css={styles} sx={{ ...sx }} {...rest} />
}
